import React from "react";
import { Flex } from "antd";
import {
  StatCardStyled,
  IconAvatar,
  CardTitleText,
  CardBody,
  CardSubText,
  CardDivider,
  FootHintText,
  ExpandLinkText,
} from "../Dashboard.styles";

// Shared shell for the 4 dashboard summary cards. Gives every card the same
// structure — icon-badge header (bordered, via antd Card's own `title`),
// equal height, and a footer hint row — so the grid reads as one consistent
// set instead of four differently-shaped cards.
const StatWidgetCard = ({ icon, color, label, sub, footHint, onClick, children }) => (
  <StatCardStyled
    hoverable
    size="small"
    onClick={onClick}
    styles={{
      header: { background: "#F7F7F7" },
      body: { flex: 1, display: "flex", flexDirection: "column", minHeight: 0 },
    }}
    title={
      <Flex align="center" gap={8}>
        <IconAvatar shape="square" size={26} icon={icon} $bg={color} />
        <CardTitleText>
          {label}
        </CardTitleText>
      </Flex>
    }
  >
    <CardBody>
      {children}
      {sub && (
        <CardSubText type="secondary">
          {sub}
        </CardSubText>
      )}
    </CardBody>
    <CardDivider />
    <Flex justify="space-between">
      <FootHintText type="secondary">
        {footHint}
      </FootHintText>
      <ExpandLinkText $color={color}>Expand ↗</ExpandLinkText>
    </Flex>
  </StatCardStyled>
);

export default StatWidgetCard;
